
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
<div class="table-responsive-detalhe-interno">
<table *ngIf="!isLoading" [hidden]="!dataSource || dataSource.length == 0" mat-table [dataSource]="dataSource" class="table-striped">
    <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef> Data e Hora </th>
        <td mat-cell *matCellDef="let element"> {{element.data}} </td>
    </ng-container>

    <ng-container matColumnDef="etapa">
        <th mat-header-cell *matHeaderCellDef> Etapa </th>
        <td mat-cell *matCellDef="let element"> {{element.etapa }} </td>
    </ng-container>

    <ng-container matColumnDef="responsavel">
        <th mat-header-cell *matHeaderCellDef> Responsavel </th>
        <td mat-cell *matCellDef="let element"> {{element.responsavel }} </td>
    </ng-container>

    <ng-container matColumnDef="registro">
        <th mat-header-cell *matHeaderCellDef> Registro </th>
        <td mat-cell *matCellDef="let element"> {{element.registro }} </td>
    </ng-container>

    <ng-container matColumnDef="localidade">
        <th mat-header-cell *matHeaderCellDef> Localidade </th>
        <td mat-cell *matCellDef="let element"> {{element.localidade }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>
<div *ngIf="!dataSource || dataSource?.length == 0" style="min-height: 100px" class="d-flex justify-content-center align-items-center">
    <strong>Não há informação a ser exibida!</strong>
</div>
